import {z} from 'zod'

export type StripeProductId = `prod_${string}`
export const StripeProductId = z.string().startsWith('prod_') as z.ZodType<StripeProductId>
